import { SuggestedQuestion } from './actions';

export const FLOW_KEY_DCM = 'dcm';
export const FLOW_KEY_FEEDBACK = 'feedback';
export const MENTION_LABEL = '@chuckNorris';

export const DEFAULT_SUGGESTED_QUESTIONS: SuggestedQuestion[] = [
    {
        id: '1',
        text: 'Generate One Pager',
        flowKey: 'one_pager',
    },
    {
        id: '4',
        text: 'Generate One Pager as docx',
        hint: '(takes ~7-8 mins)',
        flowKey: 'one_pager_docx',
    },
    {
        id: '3',
        display: 'What debt works for this company?',
        text: 'Give me the debt recommendations for this company and be very thorough with using all the relevant data as needed?',
    },
    {
        id: '2',
        text: 'What are the best-suited lenders for this company?',
        flowKey: FLOW_KEY_DCM,
    },
];

export enum MessageType {
    USER = 'user',
    ASSISTANT = 'assistant',
}

export const COPY_TARGET = {
    FULL_CHAT: 'fullChat',
} as const;

const namespace = 'ASK_AICA_';

/** Interval in ms for polling the org conversation list while the AskAica modal is open. */
export const CONVERSATION_LIST_POLL_MS = 25000;

export const ASK_AICA_CONSTANTS = {
    // Chat functionality constants
    INITIALISE_MESSAGE_THREAD: `${namespace}INITIALISE_MESSAGE_THREAD`,
    ADD_MESSAGE: `${namespace}ADD_MESSAGE`,
    UPDATE_MESSAGE: `${namespace}UPDATE_MESSAGE`,
    CLEAR_MESSAGES: `${namespace}CLEAR_MESSAGES`,
    SET_IS_LOADING: `${namespace}SET_IS_LOADING`,
    SET_IS_LOADING_CHAT_HISTORY: `${namespace}SET_IS_LOADING_CHAT_HISTORY`,
    SET_IS_CLEARING_CHAT: `${namespace}SET_IS_CLEARING_CHAT`,
    SET_ERROR: `${namespace}SET_ERROR`,
    SET_REASONING: `${namespace}SET_REASONING`,
    RESET_REASONING: `${namespace}RESET_REASONING`,
    UPDATE_REASONING: `${namespace}UPDATE_REASONING`,

    // UI-related constants
    SET_ASK_AICA_OPEN: `${namespace}SET_ASK_AICA_OPEN`,
    SET_ASK_AICA_SELECTED_SOURCES: `${namespace}SET_ASK_AICA_SELECTED_SOURCES`,
    SET_ASK_AICA_RIGHT_PANEL_MODE: `${namespace}SET_ASK_AICA_RIGHT_PANEL_MODE`,

    // Global suggested questions constants
    SET_GLOBAL_SUGGESTED_QUESTIONS: `${namespace}SET_GLOBAL_SUGGESTED_QUESTIONS`,
    UPDATE_GLOBAL_SUGGESTED_QUESTIONS: `${namespace}UPDATE_GLOBAL_SUGGESTED_QUESTIONS`,

    // Library constants
    SET_LIBRARY_LOADING: `${namespace}SET_LIBRARY_LOADING`,
    SET_LIBRARY_FILES: `${namespace}SET_LIBRARY_FILES`,
    ADD_LIBRARY_FILES: `${namespace}ADD_LIBRARY_FILES`,

    // Conversation list constants
    SET_CONVERSATIONS: `${namespace}SET_CONVERSATIONS`,
    SET_LOADING_CONVERSATIONS: `${namespace}SET_LOADING_CONVERSATIONS`,
    SET_SELECTED_CONVERSATION: `${namespace}SET_SELECTED_CONVERSATION`,
    RESET_CHAT_VIEW: `${namespace}RESET_CHAT_VIEW`,
};
